import React from "react"
import FilterBar from "../Components/filterBar"

const statusOption = [
  {
    id: "all",
    value: "All",
  },
  {
    id: "referred",
    value: "Referred",
  },
  {
    id: "not_referred",
    value: "Not Referred",
  },
];

const CampaignFilterBar = ({ propertiesOfOrg, selectedProperties, selectedCampaigns, campaignsForDropDown, monthRange, subOrgDetails, handleChangeProperty, handleChangeCampaigns, handleMonthRange, classes, status, handleStatusChange }) => {

  const getCustomLabelForProperties = (selected, count, name, open) => {
    if (!name) {
      return <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>Property</div>
    }
    return <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>{name}</div>
  }

  const getCustomLabelForCampaigns = (selected, count, name, open) => {
    if (!name) {
      return <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>Campaign</div>
    }
    return <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>{name}</div>
  }

  const getCustomLabelForStatus = (selected, count, name, open) => {
    if (!name) {
      return <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>Status</div>
    }
    return <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>Reffered Status({name})</div>
  }


  return (
    <FilterBar
      firstFilterData={{
        type: "selector",
        optionValue: propertiesOfOrg,
        placeholder: "Property",
        searchPlaceHolder: "Enter property name here...",
        onChange: handleChangeProperty,
        singleSelect: true,
        value: selectedProperties,
        getCustomLabel: getCustomLabelForProperties
      }}
      secondFilterData={{
        type: "dateRange",
        position: "left",
        value: monthRange,
        handleApply: handleMonthRange,
        timezoneOffset: subOrgDetails.timezoneOffset
      }}
      thirdFilterData={{
        type: "selector",
        optionValue: campaignsForDropDown,
        placeholder: "Campaign",
        searchPlaceHolder: "Enter campaign name here...",
        onChange: handleChangeCampaigns,
        singleSelect: true,
        value: selectedCampaigns,
        selectAllText: "Select all Campaigns",
        getCustomLabel: getCustomLabelForCampaigns
      }}
      fourthFilterData={{
        type: "selector",
        optionValue: statusOption,
        onChange: handleStatusChange,
        singleSelect: true,
        value: status,
        getCustomLabel: getCustomLabelForStatus,
        disableSearch: true,
        disableAllSelect: true,
        height: 145,
        width: 150,
      }}
    >
    </FilterBar>
  )

}
export default (CampaignFilterBar)